import * as config from '../app/config';

const MODULE = config.API_GATEWAY_URL + 'datasets/logs/';

export const LIST_DATASET_LOGS_ENDPOINT = MODULE + "list";